export enum TimeIntervalsInMilliseconds {
  MINUTES_5 = 5 * 60 * 1000,
  MINUTES_10 = 10 * 60 * 1000,
}
